module.exports = __webpack_public_path__ + "img/published.4221b00f.svg";